import { UserProfile } from 'api/account/models/UserProfile';
import GeofencesService from 'api/geofences/GeofencesService';
import UsersService from 'api/users/UsersService';
import Loading from 'common/services/Loading';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { Reducers } from 'store/types';

const UpdateGeofencesToTrackingDB: React.FC = () => {
    const { t } = useTranslation();
    const { addToast } = useToasts();
    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);

    const getData = async () => {
        if(UsersService.isPlatformAdmin(userProfile?.roles)){
            try {
                Loading.show();
                await GeofencesService.updateGeofencesToTrackingDB();
                Loading.hide();
                addToast(t('common.messages.record_save_success'), { appearance: 'success' });
            } catch (error) {
                Loading.hide();
                addToast(t('common.messages.error_load_info'), { appearance: 'error' });
            }
        }
    }

    useEffect(() => {
        getData();
    }, []);

    return null;
};

export default UpdateGeofencesToTrackingDB;
